// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2IZMC","title":"InfoRow_title__2kjq5"};